import { render, staticRenderFns } from "./ChatAssigned.vue?vue&type=template&id=7d0f7f66&scoped=true"
import script from "./ChatAssigned.vue?vue&type=script&lang=js"
export * from "./ChatAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0f7f66",
  null
  
)

export default component.exports